module.exports = __webpack_public_path__ + "img/image92.b610a700.png";